<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div>
        <div class="wrap">
            <div v-html="contentOne" style="margin-top: 50px"></div>
            <div style="border-left: 1px solid #dcdcdc; padding: 100px 0">
                <div class="creators-nav">
                    <div
                        v-for="(item, index) in navContent"
                        :key="item.id + item.cate_id"
                        @mouseenter="tab(index)"
                        @mouseleave="leave"
                        :style="{
                            position: 'absolute',
                            left: index * 80 + 70 + 'px',
                            bottom:index % 2 == 0 ?'42px':'-10px',
                            'text-align': 'center',
                            cursor: 'pointer',
                        }"
                    >
                        <div :class="['cont-block', { ob: index == i },{zero:index%2!=0},{model:index%2==0}]" >
                            {{ item.title }}
                        </div>
                        <div class="dot pl-one" :style="{ position: 'relative',top:index % 2 == 0 ?'-4px':'40px',}"></div>
                        <div class="active-one" v-if="i == index">
                            <img src="@/assets/strategy/active.png" alt="" />
                        </div>
                        <div style="height: 20px" v-if="i != index">
                            <div
                                class="blue-dot blue-one"
                                :style="{
                                    background:
                                        index == 7 || index == 8
                                            ? '#416a83'
                                            : '#2f3c5d',
                                }"
                            ></div>
                        </div>
                    </div>
                    <!-- <div
                        v-for="(item, index) in navContent.slice(5)"
                        :key="item.id + item.cate_id"
                        @mouseenter="tab(index + 5)"
                        @mouseleave="leave"
                        :style="{
                            position: 'absolute',
                            left: (index + 1) * 170 - 30 + 'px',
                            'text-align': 'center',
                            top: '39px',
                            cursor: 'pointer',
                        }"
                    >
                        <div style="height: 20px" v-if="i != index + 5">
                            <div
                                class="blue-dot blue-two"
                                :style="{
                                    background:
                                        index == 3 || index == 4
                                            ? '#416a83'
                                            : '#2f3c5d',
                                }"
                            ></div>
                        </div>
                        <div class="active-two" v-if="i == index + 5">
                            <img src="@/assets/strategy/active.png" alt="" />
                        </div>
                        <div class="dot pl-two"></div>
                        <div :class="['cont-block', { ob: index + 5 == i }]">
                            {{ item.title }}
                        </div>
                    </div> -->
                    <div class="title-content">
                        <span class="one">Creators Center</span
                        ><span class="two">Display Center</span>
                    </div>
                </div>

                <div class="tab_con">
                    <div
                        v-for="(item, index) in navContent"
                        :key="index"
                        :style="{ display: i === index ? 'block' : 'none' }"
                    >
                       <div v-html="item.content" class="content-serve"></div>
                    </div>
                </div>
            </div>
            <ul v-html="contentTwo" class="ul-data"></ul>
            <!-- <ul class="ul-data">
                <li>
                    <div class="line"></div>
                    <div class="dot-big"></div>
                    <div class="title">
                        Continue to Enhance MMV’s Core Platform
                    </div>
                    <div class="content">
                        MMV’s Core Platform is the engine that drives MMV’s
                        content and product development process. The functions
                        of the Core Platform are listed below. MMV will continue
                        to invest and upgrade its Core Platform to ensure that
                        it is able to the demands and challenges of a new
                        market.
                    </div>
                </li>
            </ul> -->
        </div>
        <footerBox></footerBox>
    </div>
</template>
 
<script>
import navBox from "@/components/navBox/navBox";
import footerBox from "@/components/footerBox/footerBox";
export default {
    name: "strategy",
    components: { footerBox, navBox },
    data() {
        return {
            i: 0,
            data: [],
            timer: null, // 定时器
            loading: false,
            types: "",
            fullpathImg: "",
            pathUrl: "",
            navContent: [],
            contentOne: "",
            contentTwo: "",
        };
    },
    created() {
        this.getData();
        this.timer = setInterval(() => {
            this.i += 1;
            if (this.i > this.navContent.length - 1) {
                this.i = 0; // 循环
            }
        }, 3000);
    },
    mounted() {},
    // 销毁定时器
    destroyed() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        async getData() {
            this.loading = true;
            this.$http.getStrategy().then((res) => {
                this.navContent = res.config["Single-singlepage-item"];
                this.contentOne =
                    res.config["Single-singlepage-main"][0].content.split(
                        "<hr />"
                    )[0];
                this.contentTwo =
                    res.config["Single-singlepage-main"][0].content.split(
                        "<hr />"
                    )[1];
                this.types = res.config["Banner-banner-head"][0].types;
                this.fullpathImg =
                    res.config["Banner-banner-head"][0].pic_fullpath;
                this.pathUrl = res.config["Banner-banner-head"][0].links;
                this.loading = false;
            });
        },
        tab(index) {
            this.i = index;
            clearInterval(this.timer);
            this.timer = null;
        },
        leave() {
            this.timer = setInterval(() => {
                this.i += 1;
                if (this.i > this.navContent.length - 1) {
                    this.i = 0; // 循环
                }
            }, 3000);
        },
    },
};
</script>
 
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.creators-nav {
    position: relative;
    width: 820px;
    margin: 0 auto;
    height: 50px;
    background: #2f3c5d;
    border-radius: 50px;
}
.title-content {
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    .one {
        margin: 0 200px;
        height: 50px;
        line-height: 50px;
    }
    .two {
        display: inline-block;
        width: 278px;
        text-align: center;
        background: #416a83;
        border-radius: 50px;
        height: 50px;
        line-height: 50px;
    }
}
.dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #c7c7c7;
    display: inline-block;
}
.pl-one {
    position: relative;
    top: -4px;
}
.blue-dot {
    width: 8px;
    height: 8px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background: #2f3c5d;
    display: inline-block;
}
.blue-one {
    position: relative;
}
.active-one {
    position: relative;
}
.pl-two {
    position: relative;
}
.blue-two {
    position: relative;
    top: 2px;
    left: 0px;
}
.active-two {
    position: relative;
    height: 20px;
}
.tab_con {
    width: 490px;
    margin: 100px auto 0 auto;
    background: #e3e3e3;
    color: #666666;
    padding: 20px;
    font-family: "Lucida Bright";
    font-size: 14px;
    line-height: 25px;
}
/deep/.ul-data {
    li {
        position: relative;
        padding-bottom: 60px;
        .title {
            font-weight: bold;
            font-size: 23px;
            color: #333333;
            padding: 0 0 5px 25px;
            position: relative;
            top: -10px;
        }
        .content {
            color: #666666;
            font-size: 14px;
            font-family: "Lucida Bright";
            line-height: 25px;
            padding-left: 25px;
        }
        .line {
            width: 1px;
            height: 100%;
            border-left: 1px solid #dcdcdc;
            position: absolute;
        }
    }
}
/deep/.dot-big {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #b8b8b8;
    display: inline-block;
    position: absolute;
    left: -4px;
}
/deep/.content-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #c7c7c7;
    display: inline-block;
    flex-shrink: 0;
    margin: 7px;
    position: relative;
    top: 3px;
}
.cont-block {
    color: #666666;
    font-family: "Lucida Bright";
    font-size: 14px;
    width: 150px;
}
.ob {
    font-weight: bold;
}
.zero{
    height: 100px;
    vertical-align: text-top;
    position: absolute;
    top: 80px;
    left: -65px;
}
.model{
    position: absolute;
    left: -70px;
    bottom: 50px;
}
/deep/.content-serve>div{
    display: flex;
}
</style>